import React from "react"
import styled from "styled-components"
import Link from "next/link"
import { NextSeo } from "next-seo"
import { useRouter } from "next/router"

import WinItButton from "~/components/WinItButton"
import Spacer from "~/components/Spacer"
import { CATEGORIES, CATEGORIES_URL } from "../faq/constants"
import Questions from "../../public/static/images/png/knowledge-base/questions.png"

const HR = styled.hr`
  border: none;
  height: 1px;
  background-color: ${(props) => props.theme.colors.ui.inputBorder};
  padding: 0;
  margin: 32px 0;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`

const ButtonLinks = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.theme.media.mobile`
    flex-direction: column;
  `};
  justify-content: center;
  align-items: center;
  width: 100%;
  div {
    width: 100%;
    max-width: 254px;
    margin: 10px;
  }
`

const CategoryLink = styled.a`
  ${(props) =>
    props.isActive
      ? `
    font-family: ${props.theme.fonts.avenirNextBold};
    color: ${props.theme.colors.primary};
  `
      : `
    font-family: ${props.theme.fonts.avenirNextThin};
    color: ${props.theme.colors.text.label};
  `}
  text-decoration: none;
  margin-right: 20px;
  letter-spacing: 2px;
  font-size: 1.05em;
`

const CategoryList = styled.div`
  display: flex;
  flex-direction: row;
`

const CATEGORIES_LIST = [
  {
    ids: [CATEGORIES.parking, CATEGORIES.traffic],
    slug: undefined,
    title: "All",
  },
  {
    ids: [CATEGORIES.parking],
    slug: CATEGORIES_URL[CATEGORIES.parking],
    title: "Parking",
  },
  {
    ids: [CATEGORIES.traffic],
    slug: CATEGORIES_URL[CATEGORIES.traffic],
    title: "Traffic",
  },
]

const GeneralHeader = () => {
  const router = useRouter()
  const category =
    router.query && router.query.category ? router.query.category : undefined
  return (
    <>
      <NextSeo
        title="Knowledge Base | WinIt"
        description="Access our Knowledge Base for FAQs, guides, and tips to help you navigate parking and traffic ticket disputes with WinIt."
      />
      <Container>
        <img src={Questions} alt="I have questions" />
        <h1>Questions and Answers</h1>
        <p>
          Take a look at our Frequently Asked Questions to learn more.
          <br />
          Or scroll down to learn more from our knowledge base.
        </p>
        <ButtonLinks>
          <div>
            <Link href="/how-it-works" passHref>
              <WinItButton width="100%" color="green" as="a">
                How WinIt Works
              </WinItButton>
            </Link>
          </div>
          <div>
            <Link href="/faq" passHref>
              <WinItButton width="100%" color="blue" as="a">
                View FAQs
              </WinItButton>
            </Link>
          </div>
          <div>
            <Link href="/traffic/information" passHref>
              <WinItButton width="100%" color="white" as="a">
                Information by state
              </WinItButton>
            </Link>
          </div>
        </ButtonLinks>
      </Container>
      <Spacer mobile={80} desktop={80} />
      <CategoryList>
        {CATEGORIES_LIST.map((item) => {
          return (
            <Link
              href={`/knowledge-base/${item.slug ? "[category]" : ""}`}
              as={`/knowledge-base/${item.slug ? item.slug : ""}`}
              passHref
              key={item.ids.join("")}
              scroll={false}
            >
              <CategoryLink isActive={category === item.slug}>
                {item.title}
              </CategoryLink>
            </Link>
          )
        })}
      </CategoryList>
      <HR />
    </>
  )
}

export default GeneralHeader
